import {useMemo} from 'react';

import {IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';

import {TForecastCommentsCore} from '../../../model/types';
import {createDynamicColumns} from '../table.utils';

/**
 * Хук для получения динамических колонок таблицы прогнозных комментариев
 * @param {TForecastCommentsCore[] | undefined} tableData - Данные таблицы с бэкенда
 *
 * @returns {IUseCustomTableArgs['columns']} Мемоизированный массив колонок таблицы
 */
export const useForecastCommentsColumns = (
    tableData: TForecastCommentsCore[] | undefined
): IUseCustomTableArgs['columns'] => useMemo(() => createDynamicColumns(tableData), [tableData]);
